import React from "react";
import PropTypes from "prop-types";
import Tooltip from "@mui/material/Tooltip";
import { aiStar } from "@limitless/images";
import { makeStyles } from "@mui/styles";
const useStyles = makeStyles({
  aiIcon: {
    width: "20px",
    height: "20px",
    marginLeft: 6,
    verticalAlign: "middle",
    cursor: "pointer"
  }
});
const AiReasoningStarIcon = ({
  title
}) => {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(Tooltip, {
    title: title
  }, /*#__PURE__*/React.createElement("img", {
    src: aiStar,
    alt: "AI Suggested",
    className: classes.aiIcon
  }));
};
AiReasoningStarIcon.propTypes = {
  title: PropTypes.string.isRequired
};
export default AiReasoningStarIcon;